function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17.5,
    viewBox: "0 0 16 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "file (5)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35822",
    d: "M11.2 2H5.6A1.6 1.6 0 0 0 4 3.6v12.8A1.6 1.6 0 0 0 5.6 18h9.6a1.6 1.6 0 0 0 1.6-1.6V7.6z",
    style: {
      fill: "none",
      stroke: "#6c7c8c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    },
    transform: "translate(-2 -1.25)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35823",
    d: "M13 2v5.6h5.6",
    transform: "translate(-3.8 -1.25)",
    style: {
      fill: "none",
      stroke: "#6c7c8c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceButtonIcon);
export default __webpack_public_path__ + "static/media/invoiceButtonIcon.874afa59de33be22a770ef2293831d80.svg";
export { ForwardRef as ReactComponent };